import { render, staticRenderFns } from "./WellsPage.vue?vue&type=template&id=3eca3db2&scoped=true&"
import script from "./WellsPage.vue?vue&type=script&lang=js&"
export * from "./WellsPage.vue?vue&type=script&lang=js&"
import style0 from "./WellsPage.vue?vue&type=style&index=0&id=3eca3db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca3db2",
  null
  
)

export default component.exports